<template>
  <div class="room-setting-modal-component select-none">
    <div class="room-setting-modal">
      <div class="room-setting-header">
        <div class="room-setting-title-wrapper">
          <h5 class="room-setting-title">{{ $t("setting.title") }}</h5>
          <div class="room-setting-header-btn-wrapper">
            <button class="room-setting-header-btn"
                @click="onCancel"></button>
          </div>
        </div>
      </div>
      <div class="room-setting-body">
        <RoomSettingMenu @changeMenu="changeMenu"/>
        <RoomSettingContent ref="content" :is-selected="selectedMenu"/>
      </div>
      <div class="room-setting-footer">
        <button class="room-setting-footer-btn save"
                @click="onSave">{{ $t("common.save") }}</button>
        <button class="room-setting-footer-btn cancel"
                @click="onCancel">{{ $t("common.cancel") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import RoomSettingMenu from '@/components/Room/SettingRenew/Menu'
import RoomSettingContent from '@/components/Room/SettingRenew/Content'
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import _ from "lodash";

export default {
  name: 'RoomSettingModal',
  components: {
    RoomSettingMenu,
    RoomSettingContent
  },
  data(){
    return{
      selectedMenu: "general",
      saveParams: {}
    }
  },
  computed:{
    ...mapGetters('room', ['room']),
    ...mapGetters('user', ['isEmceeRole']),
    ...mapGetters('roomSetting', [
      'roomSetting',
      'params',
    ]),
    ...mapGetters('call', [
      'currentVideoLayout',
      'currentGridVideoLayout',
      'selectedWallModeTargetScreenType',
      'isMatchedGridAndCommonLayoutType',
      'roomCall',
      'currentWebinarType',
      'isWebinarLive',
      'isWebinarWall',
    ]),
  },
  created(){
    this.initParams()
  },
  methods:{
    ...mapMutations('roomSetting', [
      'INIT_SETTING_PARAMS'
    ]),
    ...mapActions('room',[
      'changeRoomTitle',
      'changeDefinePasswd',
    ]),
    ...mapActions('roomSetting', [
      'changeCameraRole',
      'changeMicRole',
      'changeResetRole',
      'changeDefaultRoleId',
      'changeDefaultDevice',
      'changeWaitingMode',
      'changeDeviceRequired',
      'changeChatMode',
      'changeUseQnA',
      'changeUseQnAShare',
      'changeDocMargin'
    ]),
    ...mapActions('call', [
      'changeVideoQuality',
      'changeVideoLayout',
      'changeWebinarType',
    ]),
    ...mapActions('question', ['changeQuestionOpenStatus']),
    initParams(){
      this.saveParams = {
        roomTitle: this.room.roomTitle,
        definePasswd: this.room.definePasswd,
        passwd: this.room.passwd,
        defaultRoleId: this.roomSetting["defaultRoleId"],
        defaultDeviceType: this.roomSetting["defaultDeviceType"],
        defaultRoleCamera: this.roomSetting["defaultRoleCamera"],
        defaultRoleMic: this.roomSetting["defaultRoleMic"],
        defaultRoleReset: this.roomSetting["defaultRoleReset"],
        useWaitingMode: this.roomSetting["useWaitingMode"],
        isDeviceRequired: this.roomSetting["isDeviceRequired"],
        useChat: this.roomSetting["useChat"],
        videoQuality: this.roomCall.videoQuality,
        useQnA: this.roomSetting['useQnA'],
        useQnAShare: this.roomSetting['useQnAShare'],
        webinarType: this.currentWebinarType,
        videoLayout: this.currentVideoLayout,
        useDocMargin: this.roomSetting['useDocMargin'],
        wallModeTargetScreen: this.selectedWallModeTargetScreenType,
      }
      if (this.isEmceeRole() && this.isWebinarWall && !this.isMatchedGridAndCommonLayoutType) {
        this.saveParams.videoLayout = this.currentGridVideoLayout
      }
      this.INIT_SETTING_PARAMS(this.saveParams)
    },
    changeMenu(menu){
      this.selectedMenu = menu
      this.$refs.content.scrollTop= 0;
    },
    validTitle(){
      if(/[^(가-힣a-zA-Z0-9| |\-)]/gi.test(this.params.roomTitle.trim())){
        this.$alert({
          text: this.$t('setting.name.valid'),
          onlyOk: true
        });
        return false;
      }

      return true;
    },
    validPassword(){
      if(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g.test(this.params.passwd)){
        this.$alert({
          text: this.$t('setting.disclosure.password.valid'),
          onlyOk: true
        });
        return false;
      }

      return true;
    },
    onCancel() {
      this.$modal('RoomSettingModal')
    },
    async onSave() {
      try{
        if(this.params.roomTitle !== this.room.roomTitle && this.validTitle()){
          this.changeRoomTitle(this.params.roomTitle);
        }

        if(this.params.definePasswd){
          if(!this.params.passwd){
            this.$alert({
              text: this.$t('setting.disclosure.password.essential'),
              onlyOk: true
            });
            return;
          } else if(this.params.passwd !== this.room.passwd && this.validPassword()){
            this.changeDefinePasswd({definePasswd: !this.isPublic, password: this.params.passwd});
          }
        } else if (!this.params.definePasswd && this.room.definePasswd) {
          this.changeDefinePasswd({ definePasswd: this.params.definePasswd });
        }

        if(this.params.defaultRoleId !== this.roomSetting["defaultRoleId"]){
          this.changeDefaultRoleId(this.params.defaultRoleId);
        }

        if(this.params.defaultDeviceType !== this.roomSetting["defaultDeviceType"]){
          this.changeDefaultDevice(this.params.defaultDeviceType);
        }

        if(this.params.defaultRoleCamera !== this.roomSetting["defaultRoleCamera"]){
          this.changeCameraRole(this.params.defaultRoleCamera);
        }

        if(this.params.defaultRoleMic !== this.roomSetting["defaultRoleMic"]){
          this.changeMicRole(this.params.defaultRoleMic);
        }

        if(this.params.defaultRoleReset !== this.roomSetting["defaultRoleReset"]){
          this.changeResetRole(this.params.defaultRoleReset);
        }

        if(this.params.useWaitingMode !== this.roomSetting["useWaitingMode"]){
          this.changeWaitingMode(this.params.useWaitingMode);
        }

        if(this.params.isDeviceRequired !== this.roomSetting["isDeviceRequired"]){
          this.changeDeviceRequired(this.params.isDeviceRequired);
        }

        if(this.params.useChat !== this.roomSetting["useChat"]){
          this.changeChatMode(this.params.useChat);
        }

        if(this.params.videoQuality !== this.roomCall.videoQuality){
          this.changeVideoQuality(this.params.videoQuality);
        }

        if(this.params.videoQuality !== this.roomCall.videoQuality){
          this.changeVideoQuality(this.params.videoQuality);
        }

        if(this.params.useQnA !== this.roomSetting["useQnA"]){
          this.changeUseQnA(this.params.useQnA);
        }

        if(this.params.useQnAShare !== this.roomSetting["useQnAShare"]){
          this.changeUseQnAShare(this.params.useQnAShare);
        }

        if(this.params.webinarType !== this.currentWebinarType){
          await this.changeWebinarType(this.params.webinarType);
        }

        if(this.params.webinarType !== 'live' && this.params.videoLayout !== this.currentVideoLayout){
          if(!this._changeVideoLayout){
            this._changeVideoLayout = _.debounce((videoLayout)=>{
              this.changeVideoLayout({layoutType:videoLayout})
            }, 500, {
              leading: true
            })
          }

          this._changeVideoLayout(this.params.videoLayout);
        }

        if(this.params.useDocMargin !== this.roomSetting["useDocMargin"]){
          this.changeDocMargin(this.params.useDocMargin);
        }
        this.$modal('RoomSettingModal')
      } catch (e){
        console.error('setting save error', e);
        this.$alert({
          text: this.$t('common.errorAlert'),
          onlyOk: true
        });
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.room-setting-modal-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
}

.room-setting-modal {
  display: flex;
  flex-direction: column;
  width: 520px;
  height: 600px;
  border-radius: 12px;
  background: #fff;
  transition: .5s ease all;
}

.room-setting-header{
  width: 100%;
  padding: 12px 20px;
  border-bottom: 1px solid #ccc;

  .room-setting-title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-align: center;

    .room-setting-title {
      font-size: 16px;
      font-weight: 700;
      color: #333;
      line-height: 19px;
    }

    .room-setting-header-btn-wrapper {
      line-height: 0;
    }

    .room-setting-header-btn {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      background: url('~@/assets/images/x.svg') no-repeat center / 40% auto;
      opacity: 0.5;

      &:hover {
        background: rgba(0,0,0,0.7) url('~@/assets/images/x_white.svg') no-repeat center / 40% auto;
        opacity: 1;
      }
    }
  }
}

.room-setting-body{
  display: flex;
  min-height: 500px;
}

.room-setting-footer{
  display: flex;
  justify-content:flex-end;
  padding: 10px 20px;
  border-top: 1px solid #ccc;

  .room-setting-footer-btn{
    width: 60px;
    height: 30px;
    margin-left: 8px;
    border-radius: 6px;
    background-color: #59f;
    font-size: 13px;
    color: #fff;
    pointer-events: auto;

    &.cancel{
      background-color: #eaeaea;
      font-weight: normal;
      color: #888;

      &:hover{
        background-color: #ddd;
      }
    }

    &.save{
      background-color: #59f;
      &:hover {
        background-color: #1b59f6;
      }
    }

    &:first-child {
      margin: 0;
    }
  }
}


[grm-device-mobile]{
  .room-setting-modal{
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .room-setting-body{
    display: flex;
    min-height: 0;
    flex: 1;
  }
}
</style>